<template>
  <div id="videos">
    <div v-if="videos.length">
      <div v-if="isShowBuy" class="title">
        <h1>{{ title }}</h1>
        <h2>{{ subtitle }}</h2>
      </div>
      <div v-if="current" class="video" ref="video">
        <video :id="'TCPlayer' + nonce" :src="current.url" playsinline webkit-playsinline></video>
        <div class="video__overlay">
          <h1>{{ current.title }}</h1>
          <h2>{{ current.subtitle }}</h2>
        </div>
      </div>
      <div class="preview">
        <div v-for="item in videos" :key="item.video_id" class="preview__item" @click="play(item)">
          <div v-lazy:background-image="item.img" class="preview__bgd">
            <div v-if="current.video_id === item.video_id" class="preview__overlay animated fadeIn">
              <i class="anyteachicon anyteach-zhengzaibofang" />
            </div>
            <i class="preview__current animated fadeIn" v-if="current.video_id === item.video_id" />
          </div>
          <div class="preview__text">
            <h1>{{ item.title }}</h1>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isShowBuy && isShowMore" class="more">
      <router-link
        to="/live/features"
        class="special promo__d11"
        tag="div"
        v-if="$store.state.isPromo"
      >
        <h1>
          <i class="anyteachicon anyteach-1212 promo-icon" />
          <span>探索趣蒙课</span>
        </h1>
        <h2>{{ $store.state.promoData.desc1 }}</h2>
      </router-link>
      <router-link to="/live/features" class="special" tag="div" v-else>
        <h2>
          欧美外教真人直播，30000+ 位妈妈的选择
          <i class="anyteachicon anyteach-next1" />
        </h2>
      </router-link>
    </div>
  </div>
</template>

<script>

export default {
  name: "Videos",
  props: {
    isShowBuy: {
      type: Boolean
    },
    videoType: {
      type: String,
      default: "10"
    },
    isShowMore: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      title: "精彩回放",
      subtitle: "真人融合动画，学得有趣记得牢",
      videos: [],
      vod: [],
      nonce: parseInt(Math.random() * 1000000),
      current: null,
      TCPlayer: null,
      appID: "1257393913",
    }
  },
  mounted() {
    this.getVideoList()
  },
  beforeDestroy() {
    this.TCPlayer = null
  },
  methods: {
    play(item) {
      if (this.current && this.current.video_id === item.video_id) {
        return
      }
      this.current = item
      if (!this.TCPlayer) {
        this.$nextTick(() => {
          let width = 0.9
          let height = document.body.clientWidth * width * 9 / 16
          this.$refs.video.style.width = width * 100 + "%"
          this.$refs.video.style.height = height + "px"
          this.TCPlayer = TCPlayer("TCPlayer" + this.nonce, {
            fileID: item.video_id,
            appID: this.appID,
            width,
            height,
            controlBar: {
              playbackRateMenuButton: false,
              volumePanel: false,
              QualitySwitcherMenuButton: false,
            },
          })
        })
      } else {
        this.$nextTick(() => {
          this.TCPlayer.loadVideoByID({
            fileID: item.video_id,
            appID: this.appID,
          })
          this.TCPlayer.on("canplay", () => {
            this.TCPlayer.play()
          })
        })
      }
    },
    async getVideoList() {
      this.videos = await this.$api.videos.LIST(this.videoType)
      if (this.videos.length) {
        this.play(this.videos[0])
        this.title = this.videos[0].videos_type_title
        this.subtitle = this.videos[0].videos_type_subtitle
      }
    },
  },
}
</script>
<style>
@import "https://imgcache.qq.com/open/qcloud/video/tcplayer/tcplayer.css";
</style>

<style lang="scss">
// @import "../../../static/css/public.scss";

#videos {
  i {
    font-size: inherit;
  }
  .video-js {
    border-radius: 3px;
    width: 100%;
    box-shadow: 0 0 25px 0 #efefef;
    button {
      &:hover,
      &:active {
        background: none;
      }
    }
  }
  .vjs-control-bar {
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    font-size: 0.6rem;
  }
  .vjs-current-time-display,
  .vjs-duration-display {
    @include avenir();
    font-size: 0.8rem;
  }

  .tcp-quality-switcher-value * {
    color: white;
    font-weight: 500;
    font-size: 0.9rem;
  }

  .vjs-poster {
    border-radius: 3px;
  }
  .vjs-menu-content {
    border-radius: 5px;
    bottom: 10px;
    * {
      font-size: 0.9rem;
      font-weight: 500;
    }
  }

  @media only screen and (min-width: 600px) {
    .video-js {
      max-height: 500px;
    }
  }
}
</style>
<style lang="scss" scoped>
@import "../../../static/css/carousel.scss";
@import "@/assets/css/promo.scss";

#videos {
  width: 100%;
  margin: 0 auto 20px auto;

  h1 {
    font-size: 1.25rem;
    font-weight: bold;
    margin-bottom: 5px;
  }

  h2 {
    @include avenir-demi();
    font-size: 0.9rem;
    padding-right: 5%;
    opacity: 0.6;
  }

  .title {
    padding: 0 5%;
    margin: 20px 0 15px 0;
    h2 {
      font-weight: 400;
    }
  }

  .video {
    width: 90%;
    margin: 0 5%;
    border-radius: 3px;
    position: relative;

    video {
      border-radius: 3px;
      position: relative;
    }
    .video__overlay {
      position: absolute;
      background: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0));
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
      width: 100%;
      left: 0;
      top: 0;
      padding: 0.5rem 10px 30px 10px;
      * {
        color: white;
      }
      h1 {
        @include avenir();
        font-size: 1rem;
        font-weight: 500;
        margin: 0;
        line-height: 1.3;
      }
      h2 {
        font-size: 0.8125rem;
        font-weight: 400;
      }
    }
  }

  .preview {
    $preview__width: 120px;
    $preview__height: 75px;
    width: 100%;
    overflow: auto;
    margin: 15px 0 0 0;
    white-space: nowrap;
    .animated {
      animation-duration: 0.1s !important;
    }
    .preview__bgd {
      width: $preview__width;
      height: $preview__height;
      border-radius: 3px;
      box-shadow: 0 0 25px 0 #efefef;
      background: $black;
      position: relative;
      margin: 0 0 10px 0;
      background-color: #eee;
      background-size: cover;
      background-position: center center;
    }
    .preview__current {
      border: 2px solid $blue;
      display: block;
      position: absolute;
      border-radius: 3px;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
    .preview__item {
      width: $preview__width;
      box-sizing: content-box;
      display: inline-block;
      margin-right: 15px;
      vertical-align: top;
      transition: all 0.1s;
      &:active {
        opacity: 0.6;
      }

      &:first-of-type {
        margin-left: 5%;
      }
      &:last-of-type {
        margin-right: 5%;
      }

      .preview__text {
        white-space: initial;
        h1 {
          font-size: 0.8rem;
          line-height: 1.2;
          @include avenir();
          text-overflow: ellipsis;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
    .preview__overlay {
      background-color: rgba(0, 0, 0, 0.7);
      width: 100%;
      height: 100%;
      position: absolute;
      border-radius: 3px;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        font-size: 1.5rem;
        color: white;
      }
    }
  }
  .video-container {
    width: 100%;
    white-space: nowrap;
    overflow: scroll;
    .video-wrapper {
      width: 100%;
      white-space: wrap;
      display: inline-block;
      position: relative;
      border-radius: 3px;
      margin: 0 15px 0 0;
      h1 {
        @include avenir();
        font-size: 0.8125rem;
        font-weight: 500;
        top: 0;
        margin: 0;
        left: 0;
        color: white;
        position: absolute;
        background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        width: 100%;
        padding: 0.5rem 10px 20px 10px;
        line-height: 1.4;
      }
    }
  }
  .more {
    width: 90%;
    margin: 10px auto 0 auto;

    .special {
      width: 100%;
      transition: all 0.1s;
      padding: 0 0 5px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      transition: all 0.1s;
      color: $red;
      i {
        font-size: 0.8rem;
      }

      &:active {
        opacity: 0.6;
      }
      h2 {
        @include avenir-demi();
        font-size: 0.8rem;
        color: $red;
        line-height: 1.1;
        margin: 0;
        padding: 0;
        opacity: 1;
      }
    }
    .promo__d11 {
      h1 {
        color: $d11__main;
      }
    }
  }
}
// iPhone 4
@media screen and (max-width: 320px) {
}

// iPhone 5, 6
@media screen and (min-width: 321px) and (max-width: 414px) {
}

// Tablet
@media only screen and (min-width: 600px) {
  #videos .video video {
    height: 300px;
  }
}

// iPad landscape
@media only screen and (min-width: 1024px) {
}
</style>
